import { render, staticRenderFns } from "./WxpublicTemplateNotice.vue?vue&type=template&id=3478ffb5"
import script from "./WxpublicTemplateNotice.vue?vue&type=script&lang=js"
export * from "./WxpublicTemplateNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports